// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateInput-module__root__tLLBm {
  width: fit-content;
  max-width: 100%;
}

.DateInput-module__root__tLLBm .mantine-DatePickerInput-input {
  min-width: 10.5rem;
  cursor: pointer;
  text-align: left;
}

.DateInput-module__calendarIcon__auq2a {
  color: var(--mantine-color-dimmed);
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/DateInput/DateInput.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".root {\n  width: fit-content;\n  max-width: 100%;\n}\n\n.root :global(.mantine-DatePickerInput-input) {\n  min-width: 10.5rem;\n  cursor: pointer;\n  text-align: left;\n}\n\n.calendarIcon {\n  color: var(--mantine-color-dimmed);\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DateInput-module__root__tLLBm`,
	"calendarIcon": `DateInput-module__calendarIcon__auq2a`
};
module.exports = ___CSS_LOADER_EXPORT___;
